import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonConfigurationClass;
function JsonConfiguration() {
  if (JsonConfigurationClass === VOID) {
    class $ {
      constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode, exceptionsWithDebugInfo) {
        encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
        ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
        isLenient = isLenient === VOID ? false : isLenient;
        allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
        prettyPrint = prettyPrint === VOID ? false : prettyPrint;
        explicitNulls = explicitNulls === VOID ? true : explicitNulls;
        prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
        coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
        useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
        classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
        allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
        useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
        namingStrategy = namingStrategy === VOID ? null : namingStrategy;
        decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
        allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
        allowComments = allowComments === VOID ? false : allowComments;
        classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
        exceptionsWithDebugInfo = exceptionsWithDebugInfo === VOID ? true : exceptionsWithDebugInfo;
        this.g2n_1 = encodeDefaults;
        this.h2n_1 = ignoreUnknownKeys;
        this.i2n_1 = isLenient;
        this.j2n_1 = allowStructuredMapKeys;
        this.k2n_1 = prettyPrint;
        this.l2n_1 = explicitNulls;
        this.m2n_1 = prettyPrintIndent;
        this.n2n_1 = coerceInputValues;
        this.o2n_1 = useArrayPolymorphism;
        this.p2n_1 = classDiscriminator;
        this.q2n_1 = allowSpecialFloatingPointValues;
        this.r2n_1 = useAlternativeNames;
        this.s2n_1 = namingStrategy;
        this.t2n_1 = decodeEnumsCaseInsensitive;
        this.u2n_1 = allowTrailingComma;
        this.v2n_1 = allowComments;
        this.w2n_1 = classDiscriminatorMode;
        this.x2n_1 = exceptionsWithDebugInfo;
      }
      toString() {
        return 'JsonConfiguration(encodeDefaults=' + this.g2n_1 + ', ignoreUnknownKeys=' + this.h2n_1 + ', isLenient=' + this.i2n_1 + ', ' + ('allowStructuredMapKeys=' + this.j2n_1 + ', prettyPrint=' + this.k2n_1 + ', explicitNulls=' + this.l2n_1 + ', ') + ("prettyPrintIndent='" + this.m2n_1 + "', coerceInputValues=" + this.n2n_1 + ', useArrayPolymorphism=' + this.o2n_1 + ', ') + ("classDiscriminator='" + this.p2n_1 + "', allowSpecialFloatingPointValues=" + this.q2n_1 + ', ') + ('useAlternativeNames=' + this.r2n_1 + ', namingStrategy=' + toString(this.s2n_1) + ', decodeEnumsCaseInsensitive=' + this.t2n_1 + ', ') + ('allowTrailingComma=' + this.u2n_1 + ', allowComments=' + this.v2n_1 + ', classDiscriminatorMode=' + this.w2n_1.toString() + ', exceptionsWithDebugInfo=' + this.x2n_1 + ')');
      }
    }
    initMetadataForClass($, 'JsonConfiguration');
    JsonConfigurationClass = $;
  }
  return JsonConfigurationClass;
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new (ClassDiscriminatorMode())('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new (ClassDiscriminatorMode())('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new (ClassDiscriminatorMode())('POLYMORPHIC', 2);
}
var ClassDiscriminatorModeClass;
function ClassDiscriminatorMode() {
  if (ClassDiscriminatorModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ClassDiscriminatorMode');
    ClassDiscriminatorModeClass = $;
  }
  return ClassDiscriminatorModeClass;
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
//region block: exports
export {
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance as ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance2lvfujkupldw2,
  ClassDiscriminatorMode_NONE_getInstance as ClassDiscriminatorMode_NONE_getInstancen9ln5ytvklfv,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance as ClassDiscriminatorMode_POLYMORPHIC_getInstanceeiwfq8nevyzz,
  JsonConfiguration as JsonConfiguration2bv2x41u8reet,
};
//endregion

//# sourceMappingURL=JsonConfiguration.mjs.map
